import React, { Suspense, lazy } from 'react';
import { isKidsHost } from './apps/shared/productHost';

const EventsApp = lazy(() => import('./apps/events/EventsApp'));
const KidsApp = lazy(() => import('./apps/kids/KidsApp'));

function App() {
  const SelectedApp = isKidsHost() ? KidsApp : EventsApp;

  return (
    <Suspense fallback={null}>
      <SelectedApp />
    </Suspense>
  );
}

export default App;
